<template>
  <div
    v-if="isLoggedIn"
    class="library-shows container"
    data-test="libarary-shows">
    <loader
      v-show="!podcasts_loaded"
      center
      label="Fetching Podcasts ..."/>
    <library-menu
      :display-grid="true"
      :text="podcasts.length + ' Show' + (podcasts.length > 1 || !podcasts.length ? 's' : '')"/>
    <!-- Empty Shows Box -->
    <empty-shows
      v-show="!podcasts.length && podcasts_loaded"
      option="shows"/>
    <!-- Display Podcasts -->
    <div
      v-if="podcasts.length && podcasts_loaded"
      class="podcast-grid container">
      <draggable
        v-model="podcasts"
        :options="draggableOptions"
        class="el-row el-row--flex d-flex-wrap"
        @start="onPodcastDragStart"
        @end="onPodcastDragEnd">
        <el-col
          v-for="(item,index) in podcasts"
          :md="6"
          :sm="6"
          :xs="12"
          :key="index"
          class="m-t-2"
          data-test="list-shows">
          <show-card
            :podcast="item.podcast"
            :last-viewed-at="item.last_viewed_at"
            :latest-episode="item.latest_episode"
            :episode-count="item.recent_episode_count > 0"
            data-test="shows"
            @podcastClicked="updatePodcastLastViewedAt(item, index)"
          />
        </el-col>
      </draggable>
      <loader
        v-show="podcasts.length && loading_more_shows && !no_more_shows"
        :with-margin="true"/>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import draggable from 'vuedraggable';
import Podcast from '../../services/Podcast';
import User from '../../services/User';
import SegmentEvent from '../../services/PlayerEvent';
import ShowCard from '../../components/ShowCard';
import loader from '../../components/Loader';
import EmptyShows from '../../components/EmptyShows';
import LibraryMenu from '../../components/LibraryMenu';
import ScrollMixin from '../../shared/scrollMixin';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Shows',
  components: {
    draggable,
    loader,
    'show-card': ShowCard,
    'empty-shows': EmptyShows,
    'library-menu': LibraryMenu,
  },
  mixins: [ScrollMixin, PageMixin],
  data() {
    return {
      pageName: 'My Shows',
      podcast_service: new Podcast(),
      user_service: new User(),
      podcasts: [],
      scroll_threshold: 300,
      show_limit: 12,
      page: 0,
      isLoggedIn: this.$store.getters.loggedIn,
      podcasts_loaded: false,
      no_more_shows: false,
      loading_more_shows: false,
      draggableOptions: {
        animation: 500,
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        dragClass: 'drag',
        delay: 50,
        scrollSensitivity: 15,
        scrollSpeed: 50,
        scroll: true,
      },
      eventProvider: new SegmentEvent(),
      bucket: {},
    };
  },
  beforeMount() {
    if (this.isLoggedIn) {
      this.getPodcastsFromLibrary();
    }
    if (window && window.innerWidth <= this.screenSize.sm) this.draggableOptions.delay = 200;
    this.parentSelector = 'podcast-grid';
    this.childSelector = '.podcast-grid .show-card.is-visible';
  },
  beforeDestroy() {
    this.removeScrollEvent();
  },
  mounted() {
    this.infiniteScrollPodcasts();
    this.bucket = {
      bucket_uuid: null,
      name: 'My Shows',
      bucket_type: 'podcasts',
      position: 0,
      media_size: 'thumbnail',
    };
  },
  methods: {
    getPodcastsFromLibrary() {
      this.loading_more_shows = true;
      if (this.no_more_shows) {
        this.podcasts_loaded = true;
        return;
      }
      this.podcast_service.getPodcastsFromLibrary(this.show_limit, ++this.page)
        .then((pods) => {
          this.podcasts = this.podcasts.concat(pods.podcasts || []);
          this.loading_more_shows = false;
          this.no_more_shows = this.podcasts.length >= pods.total;
          this.podcasts_loaded = true;
          this.mapPodcastDataIntoLatestEpisodeData();
          // TODO: need to replace timeout and wait for elements rendering to capture content viewed without scroll
          // setTimeout(() => {
          //   this.watchEpisodeListScroll();
          // }, 500)
          this.contentList = this.podcasts.map(userPodcast => userPodcast.podcast);
        })
        .catch((err) => { log.warn(err.message); });
    },
    calculatePodcastEpisodeCount(podcasts) {
      if (podcasts && Array.isArray(podcasts)) {
        podcasts.forEach((item) => {
          const sLength = (item.podcast && item.podcast.seasons && item.podcast.seasons.length) || 0;
          if (!sLength) return;
          const season = item.podcast.seasons[sLength - 1];
          const episodeLength = (season.episodes && season.episodes.length) || 0;
          if (!episodeLength) return;
          const episode = season.episodes[episodeLength - 1];
          podcasts.push({
            ...item,
            recent_episode_count: item.last_viewed_at ? new Date(episode.updated_at) > new Date(item.last_viewed_at) : true,
          });
        });
        return podcasts;
      }
      return [];
    },
    infiniteScrollPodcasts() {
      // if (!this.podcasts.length) return;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
      document.getElementsByTagName('body')[0].addEventListener('scroll', this.infiniteScrollPodcastsCallback);
    },
    infiniteScrollPodcastsCallback() {
      const heightLimit = document.body.scrollTop + window.innerHeight + this.scroll_threshold >= document.body.scrollHeight;
      if (heightLimit && !this.loading_more_shows) {
        log.info('Height limit called');
        this.getPodcastsFromLibrary();
      }
    },
    removeScrollEvent() {
      const body = document.getElementsByTagName('body')[0];
      body.style = {};
      document.getElementsByTagName('body')[0].removeEventListener('scroll', this.infiniteScrollPodcastsCallback);
    },
    onPodcastDragStart() {
    },
    onPodcastDragEnd(evt) {
      if (evt.oldIndex !== evt.newIndex) {
        this.updatePodcastPosition(this.podcasts[evt.newIndex], evt.newIndex + 1);
      }
    },
    updatePodcastLastViewedAt(userPodcast, podcastPosition) {
      this.podcast_service.updatePodcastViewDate(userPodcast.uuid).then().catch((err) => { log.warn(err.message); });

      const bucketItemData = { ...userPodcast.podcast };
      bucketItemData.item_position = podcastPosition;
      this.eventProvider.triggerContentSelectEvent(this.bucket, bucketItemData);
    },
    deletePodcastFromLibrary(uuid) {
      this.podcast_service.deletePodcastFromLibrary(uuid).then().catch((err) => { log.warn(err.message); });
    },
    updatePodcastPosition(userPodcast, pos) {
      this.podcast_service.updatePodcastPosition(userPodcast.uuid, pos)
        .then((res) => {
          if (res && res.success) this.eventProvider.triggerMyShowsReorderEvent(userPodcast.podcast.uuid, res.new_position, pos);
        })
        .catch((err) => { log.warn(err.message); });
    },
    mapPodcastDataIntoLatestEpisodeData() {
      for (let i = 0; i < this.podcasts.length; i++) {
        if (this.podcasts[i] && this.podcasts[i].uuid && this.podcasts[i].latest_episode) {
          this.podcasts[i].latest_episode.season = {
            podcast: this.podcasts[i].podcast,
          };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.library-shows {
  .top-bar {
    margin: 0 0;
  }
  .ghost {
    opacity: 0 !important;
  }
}
@media (max-width: 576px) {
  .library-shows {
    .top-bar {
      padding-bottom: 0 !important;
      margin: 0 5px !important;
    }
    .container {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/user_library/Shows.vue